// extracted by mini-css-extract-plugin
export default {"layout":"ToggleButton_layout__VUS79","selected":"ToggleButton_selected__38x3+"};